import { BehaviorSubject, catchError, firstValueFrom, map, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { ICurrentUser } from '../../interfaces';
import { UserProfileData } from '../../models/user-data';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private readonly _currentUserSubject: BehaviorSubject<ICurrentUser | null>;
  constructor(private http: HttpClient) {
    this._currentUserSubject = new BehaviorSubject<ICurrentUser | null>(null);
  }

  async loadCurrentUser(): Promise<void> {
    const url = `${environment.incopescaDigitalService.apiServer}${environment.endpoints.userMe}`;
    this.currentUser = await firstValueFrom(
      this.http.get<UserProfileData>(url).pipe(
        map(user => user),
        catchError(() => {
          return of(null);
        })
      )
    );
  }

  get currentUserSubject(): BehaviorSubject<ICurrentUser | null> {
    return this._currentUserSubject;
  }
  set currentUser(user: ICurrentUser | null) {
    this._currentUserSubject.next(user);
  }
  get currentUser(): ICurrentUser | null {
    return this._currentUserSubject.value;
  }
}
